import { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'

const NotificationSkeleton = (): ReactNode => <Skeleton className="h-[80px] w-full" />

const NotificationsListSkeleton = (): ReactNode => (
  <div className="flex w-full flex-col items-center justify-center gap-3 bg-bg-primary px-6 py-4">
    <NotificationSkeleton />
    <NotificationSkeleton />
    <NotificationSkeleton />
  </div>
)

export default NotificationsListSkeleton
